import React from 'react';
import { History } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { LoadingSpinner } from '@/components/loading-spinner';
import { cn } from '@/lib/utils';

interface PastRunsButtonProps {
  disabled?: boolean;
  isLoadingRun?: boolean;
  /** True while a past run is open — tints the icon amber. */
  isViewingPastRun?: boolean;
  onClick: () => void;
  /** Button variant. Defaults to 'ghost' (original). Use 'outline' for the new canvas cluster. */
  variant?: 'ghost' | 'outline';
}

export const PastRunsButton: React.FC<PastRunsButtonProps> = ({
  disabled = false,
  isLoadingRun = false,
  isViewingPastRun = false,
  onClick,
  variant = 'ghost',
}) => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          size='icon'
          variant={variant}
          disabled={disabled || isLoadingRun}
          onClick={onClick}
          aria-label='Past Runs'
          aria-pressed={isViewingPastRun}
          className={cn(
            isViewingPastRun &&
              'text-amber-600 hover:bg-amber-50 hover:text-amber-700 dark:text-amber-400 dark:hover:bg-amber-500/10 dark:hover:text-amber-400',
          )}
        >
          {isLoadingRun ? <LoadingSpinner /> : <History className='size-4' />}
        </Button>
      </TooltipTrigger>
      <TooltipContent side='bottom'>
        {isViewingPastRun ? 'Viewing a past run' : 'Past Runs'}
      </TooltipContent>
    </Tooltip>
  );
};
